import { render, staticRenderFns } from "./FastSearchMenu.vue?vue&type=template&id=5497a8e1"
import script from "./FastSearchMenu.vue?vue&type=script&lang=js"
export * from "./FastSearchMenu.vue?vue&type=script&lang=js"
import style0 from "./FastSearchMenu.vue?vue&type=style&index=0&id=5497a8e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports